import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import request from '../../../helpers/request';

const getStatuses = async () => {
  return await request.get(
    '/Docs/statuses',
    null,
    'Произошла ошибка при загрузке статусов документа'
  );
};

const useStatusesQuery = (options) =>
  useQuery(queryKeys.statuses(), getStatuses, options);

export default useStatusesQuery;
